import { Pagination } from '@mam/main/Api/Pagination';
import {
	GenericNotification,
	mapNotification,
	Notification,
	NotificationPriority,
} from '@mam/main/Api/Pigeon/Notification';
import { Request } from '@mam/main/ApiClient';

export enum NotificationStatus {
	All = 'all',
	Read = 'read',
	Priority = 'priority',
}

export interface NotificationsResponse {
	readonly items: Notification[];
	readonly pagination: Pagination;
}

export interface EncodedNotificationsResponse {
	readonly items: Array<GenericNotification<string>>;
	readonly pagination: Pagination;
}

export enum NotificationsError {}

export class NotificationsRequest implements Request<NotificationsResponse, EncodedNotificationsResponse> {
	public readonly api = 'pigeon';
	public readonly knownErrorCodes = Object.values(NotificationsError);
	public readonly path: string;

	public constructor(page: number, perPage: number, status: string) {
		const params = buildParams(page, perPage, status);
		this.path = `notifications?${params.toString()}`;
	}

	public decode(response: EncodedNotificationsResponse): NotificationsResponse {
		return {
			...response,
			items: response.items.map(mapNotification),
		};
	}
}

const buildParams = (page: number, perPage: number, status: string) => {
	const params = [];

	params.push(['page', String(page)]);
	params.push(['perPage', String(perPage)]);
	params.push(['filter-security-sensitive', 'remove']);

	const filterRead = getFilterRead(status);
	if (filterRead !== null) {
		params.push(['filter-read', filterRead]);
	}

	const filterPriority = getFilterPriority(status);
	if (filterPriority !== null) {
		params.push(['filter-priority', filterPriority]);
	}

	return new URLSearchParams(params);
};

const getFilterRead = (status: string) => {
	switch (status) {
		case NotificationStatus.Read:
			return 'true';
		case NotificationStatus.All:
		case NotificationStatus.Priority:
		default:
			return null;
	}
};

const getFilterPriority = (status: string) => {
	switch (status) {
		case NotificationStatus.Priority:
			return NotificationPriority.High;
		case NotificationStatus.All:
		case NotificationStatus.Read:
		default:
			return null;
	}
};
